module.exports = __webpack_public_path__ + "img/image_17.cb11de31.png";